export default "__VITE_ASSET__Chfff5Ys__"